<template>
  <div id="swiperBodyList">
    <div id="bodyLits" v-for="item in data" :key="item.id" @click="open(item.id)">
      <div id="name">{{item.title}}</div>
      <div id="line"></div>
      <div id="title_content" style v-html="item.content"></div>
      <span>...</span>
      <div id="data">{{item.pubdate}}</div>
      <div id="line"></div>
    </div>
    <!--<div style="text-align:center">-->
    <!--<el-pagination background layout="prev, pager, next" :total="total"></el-pagination>-->
    <!--</div>-->
  </div>
</template>
<script>
export default {
  props: ["data"],
  methods: {
    open(id) {
      this.$router.push({ name: "body", query: { id: id } });
    }
  }
};
</script>
<style lang="less" type="text/css">
 #title_content img {
   display: none;
 }
</style>
<style lang="less" scoped>
#swiperBodyList {
  margin-top: 30px;
  padding-bottom: 20px;
}
#bodyLits {
  background: #f8f8f8;
  padding: 50px 100px;
  width: 850px;
  margin: 20px auto;
  color: #575757;
  #name {
    font-size: 20px;
    font-weight: 600;
  }
  #title_content {
    font-size: 15px;
    padding: 2px;
    /deep/ :nth-of-type(n + 3) {
      display: none;
    }
    p :nth-of-type(n + 4){
      display: none;
    }
  }
  #data {
    font-size: 14px;
    margin-top: 10px;
  }
  #line {
    background-image: url(../assets/img/bar8.png);
    height: 20px;
    margin: 10px auto;
    background-size: 100% 100%;
  }
}
</style>
